import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const STEPS = [
  {
    title: "Ad account id",
    body: "In Meta Ads Manager, open Account Overview or Business Settings > Ad accounts. Copy the number shown as the account id (with or without act_). Enter digits only.",
  },
  {
    title: "Facebook page id",
    body: "Open the Facebook page, then About > Page transparency, or Business Settings > Pages. Copy the page id. The page must be assigned to the same Business Manager or user as the ad account.",
  },
  {
    title: "Instagram user id (optional)",
    body: "Needed only to browse and boost Instagram posts. It is the id of the Instagram professional account linked to the page, found in Business Settings > Instagram accounts. It is not the @username.",
  },
  {
    title: "Access token",
    body: "Best: a System User token from Business Settings > Users > System users. Assign the system user the ad account and the page with full control, then generate a token for your Meta app with the permissions below. A normal user token also works but expires in about 60 days.",
  },
];

const PERMISSIONS = [
  ["ads_management", "create, start and pause campaigns, ad sets and ads"],
  ["ads_read", "read spend, reach and results"],
  ["pages_read_engagement", "read page posts and their engagement"],
  ["pages_show_list", "list the pages the token can reach"],
  ["leads_retrieval", "read the answers people give on lead forms (lead ads and the lead inbox)"],
  ["pages_manage_ads", "create lead forms on the page (lead ads)"],
  ["instagram_basic", "read Instagram posts (only if you add an Instagram id)"],
  ["business_management", "only if the token comes from a System User in Business Manager"],
];

export default function SetupGuide() {
  return (
    <Accordion disableGutters elevation={0} className="border border-app-border">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <span className="font-medium">How to get these values</span>
      </AccordionSummary>
      <AccordionDetails className="space-y-4 text-sm text-app-text">
        <ol className="list-decimal space-y-3 pl-5">
          {STEPS.map((step) => (
            <li key={step.title}>
              <strong>{step.title}.</strong> {step.body}
            </li>
          ))}
        </ol>
        <div>
          <p className="font-medium">Permissions the token needs</p>
          <ul className="mt-1 list-disc space-y-1 pl-5">
            {PERMISSIONS.map(([name, why]) => (
              <li key={name}>
                <code>{name}</code>: {why}
              </li>
            ))}
          </ul>
        </div>
        <p className="text-app-text-secondary">
          The token is encrypted before it is stored and is never shown again. Your Meta app needs
          Marketing API access for live ad accounts. After saving, press Test connection: it checks
          the ad account, page, Instagram account and permissions without spending anything.
        </p>
      </AccordionDetails>
    </Accordion>
  );
}
